// One face of the wheel as a full card, over the page. A click on a wheel
// card opens it. The cross on its corner, a click outside the card, or Escape
// closes it. The browser's dialog gives the focus trap and the Escape key.

import { el } from '../lib/dom';
import { createCloseButton } from './CloseButton';
import { createSpellCardFace } from './SpellCardFace';

export type WheelCardModal = {
  root: HTMLDialogElement;
  open: (spellId: string) => void;
  close: () => void;
};

export const createWheelCardModal = (onClose: () => void): WheelCardModal => {
  const card = createSpellCardFace('card--modal');
  const root = el('dialog', { className: 'modal' }, [card.root]);
  card.root.append(createCloseButton(() => root.close()));

  // The dialog element is the whole screen. A click that lands on it, and not on the card, is outside.
  root.addEventListener('click', (event) => {
    if (event.target === root) root.close();
  });
  root.addEventListener('close', onClose);

  return {
    root,
    open: (spellId) => {
      card.draw({ spellId, caster: null }, '');
      if (!root.open) root.showModal();
    },
    close: () => {
      if (root.open) root.close();
    },
  };
};
